import { useCallback, useEffect, useState } from "react";

import qs from "query-string";
import { useLocation, useNavigate } from "react-router-dom";

const ARRAY_FORMAT = "bracket";
const QUERY_OPTIONS = {
  arrayFormat: ARRAY_FORMAT,
  skipEmptyString: true,
};
export const PARSE_OPTIONS = {
  arrayFormat: ARRAY_FORMAT,
  parseBooleans: true,
};

const useSearchParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getCurrentSearch = useCallback(() => {
    const currentSearch = qs.parse(location.search, PARSE_OPTIONS);
    return currentSearch;
  }, [location.search]);

  const [search, setSearch] = useState(getCurrentSearch());

  useEffect(() => {
    setSearch(getCurrentSearch());
  }, [getCurrentSearch]);

  /**
   * Set search params with new params
   */
  const setSearchParams = useCallback(
    (searchParams, options) => {
      navigate(
        {
          pathname: location.pathname,
          search: qs.stringify(searchParams, QUERY_OPTIONS),
        },
        options,
      );
    },
    [navigate, location.pathname],
  );

  /**
   * Update existing search params with new params
   */
  const updateSearchParams = useCallback(
    (searchParams, options) => {
      // Keep current search params
      const currentSearch = qs.parse(location.search, PARSE_OPTIONS);

      navigate(
        {
          pathname: location.pathname,
          search: qs.stringify(
            {
              ...currentSearch,
              ...searchParams,
            },
            QUERY_OPTIONS,
          ),
        },
        options,
      );
    },
    [navigate, location.pathname, location.search],
  );

  return {
    search,
    setSearchParams,
    updateSearchParams,
  };
};

export default useSearchParams;
